var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "c-table",
            {
              ref: "table",
              attrs: {
                title: "LBL0002549",
                tableId: "hazardEquipmentHis",
                columns: _vm.grid.columns,
                gridHeight: _vm.grid.height,
                data: _vm.equipInfo.hazardEquipmentHistoryModels,
                usePaging: false,
                filtering: false,
                checkClickFlag: false,
                merge: _vm.grid.merge,
                selection: "multiple",
                rowKey: "inspectionNo",
              },
              scopedSlots: _vm._u([
                {
                  key: "customArea",
                  fn: function ({ props, col }) {
                    return [
                      col.name === "click"
                        ? [
                            props.row.editFlag !== "C"
                              ? _c(
                                  "q-chip",
                                  {
                                    attrs: {
                                      outline: "",
                                      square: "",
                                      color: "blue",
                                      clickable: true,
                                      editable: _vm.editable,
                                      "text-color": "white",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.linkClick(
                                          props.row,
                                          col.name
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$label("LBL0002550")) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c(
                                  "q-chip",
                                  {
                                    attrs: {
                                      color: "red",
                                      outline: "",
                                      square: "",
                                      "text-color": "white",
                                    },
                                  },
                                  [
                                    _c("q-icon", {
                                      attrs: {
                                        outline: "",
                                        name: "info",
                                        color: "red",
                                        "text-color": "white",
                                      },
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$label("LBL0002551")) +
                                        " "
                                    ),
                                  ],
                                  1
                                ),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              label: "LBLADD",
                              showLoading: false,
                              icon: "add",
                            },
                            on: { btnClicked: _vm.addItem },
                          })
                        : _vm._e(),
                      _vm.editable &&
                      _vm.equipInfo.hazardEquipmentHistoryModels.length > 0
                        ? _c("c-btn", {
                            attrs: {
                              label: "LBLREMOVE",
                              showLoading: false,
                              icon: "remove",
                            },
                            on: { btnClicked: _vm.removeItem },
                          })
                        : _vm._e(),
                      _vm.editable &&
                      _vm.equipInfo.hazardEquipmentHistoryModels.length > 0
                        ? _c("c-btn", {
                            attrs: {
                              url: _vm.insertUrl,
                              isSubmit: _vm.isSave,
                              param: _vm.equipInfo.hazardEquipmentHistoryModels,
                              mappingType: "POST",
                              label: "LBLSAVE",
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.saveHistory,
                              btnCallback: _vm.saveCallback,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "template",
                { slot: "suffixTitle" },
                [
                  _c("font", { attrs: { color: "#C10015" } }, [
                    _vm._v(" " + _vm._s(_vm.$message("MSG0000753")) + " "),
                  ]),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }